import { ENDPOINTS } from '../../environments/environment';
import { of, throwError } from 'rxjs';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { constants } from '../constants/constants';

export const translation500 = () => {
	const result = [
		// 0
		{
			[ENDPOINTS.API_GET_CHANGE_LANGUAGE]: () => {
				return throwError(new HttpErrorResponse({ status: constants.HTTP_STATUS_CODE.BACKEND_ERROR }));
			}
		}
	];

	return result;
};

export const translation200 = () => {
	const result = [
		// 0
		{
			[ENDPOINTS.API_GET_CHANGE_LANGUAGE]: () => {
				return of(new HttpResponse({ body: { statusCode: 344, status: constants.HTTP_STATUS_CODE.BACKEND_ERROR } }));
			}
		}
	];

	return result;
};
